<template>
    <div>
        <div class="row">
            <div class="col-md-6 d-md-flex align-items-baseline">
                <h1 class="mr-2">List of Production Credits</h1>
            </div>
            <!-- SEARCH FUNCTION HERE -->
            <div class="col-md-6 pb-3">
                <input-search-icon
                    v-model="filter.search"
                    @search="searchProductionCredits"
                    :placeholder="'Search Production Credit'"
                    haveItemOnRightSide
                >
                    <template v-slot:before>
                        <dropdown
                            class="pr-2"
                            :btnContent="`Status: ${statusLabel(
                                filter.status
                            )}`"
                            :itemList="status"
                            @selected="setStatus"
                        ></dropdown>
                    </template>
                    <template v-slot:after>
                        <button
                            type="button"
                            class="btn btn-secondary ml-1"
                            v-b-tooltip.hover.top
                            title="New Production Credit"
                            @click="openUpdateDialog()"
                        >
                            <span class="fas fa-plus"></span>
                        </button>
                    </template>
                </input-search-icon>
            </div>
        </div>
        <div class="card rounded-lg p-3">
            <div class="card-body overflow-auto p-0">
                <div class="table-holder table-responsive">
                    <LoaderList v-if="isLoading" class="w-100" />
                    <table v-else class="table list">
                        <thead>
                            <tr>
                                <th>
                                    <sorting
                                        :order-by="
                                            filter &&
                                            filter.sortColumn == 'name'
                                                ? filter.sortDirection
                                                : null
                                        "
                                        @sorting="
                                            orderBy =>
                                                sortingData(orderBy, 'name')
                                        "
                                        text="Name:"
                                    >
                                    </sorting>
                                </th>
                                <th>
                                    Applies To:
                                </th>
                                <th>
                                    <sorting
                                        :order-by="
                                            filter &&
                                            filter.sortColumn == 'status'
                                                ? filter.sortDirection
                                                : null
                                        "
                                        @sorting="
                                            orderBy =>
                                                sortingData(orderBy, 'status')
                                        "
                                        text="Status:"
                                    >
                                    </sorting>
                                </th>
                                <th>
                                    <sorting
                                        :order-by="
                                            filter &&
                                            filter.sortColumn == 'used'
                                                ? filter.sortDirection
                                                : null
                                        "
                                        @sorting="
                                            orderBy =>
                                                sortingData(orderBy, 'used')
                                        "
                                        text="Used:"
                                    >
                                    </sorting>
                                </th>
                                <th>Notes:</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody v-if="productionCredits">
                            <template
                                v-for="productionCredit in productionCredits"
                            >
                                <tr :key="'row-' + productionCredit.id">
                                    <td>{{ productionCredit.name }}</td>
                                    <td>
                                        {{
                                            categoryLabel(
                                                productionCredit.all_category,
                                                productionCredit.production_credit_categories
                                            )
                                        }}
                                    </td>
                                    <td>
                                        {{
                                            statusLabel(productionCredit.status)
                                        }}
                                    </td>
                                    <td>
                                        {{ productionCredit.total_used }}
                                    </td>
                                    <td>{{ productionCredit.notes || "-" }}</td>
                                    <td class="text-right small text-nowrap">
                                        <div>
                                            <span
                                                class="cursor-pointer"
                                                @click="
                                                    openUpdateDialog(
                                                        productionCredit
                                                    )
                                                "
                                            >
                                                Edit
                                            </span>
                                            <span>|</span>
                                            <span
                                                class="cursor-pointer"
                                                @click="
                                                    openUpdateDialog(
                                                        productionCredit,
                                                        true
                                                    )
                                                "
                                            >
                                                Duplicate
                                            </span>
                                            <span>|</span>
                                            <span
                                                class="cursor-pointer"
                                                @click="
                                                    remove(productionCredit)
                                                "
                                            >
                                                {{
                                                    productionCredit.total_used.toUpperCase() ===
                                                    "NO"
                                                        ? "Delete"
                                                        : "Disable"
                                                }}
                                            </span>
                                        </div>
                                    </td>
                                </tr></template
                            >
                        </tbody>

                        <tbody v-if="productionCredits.length == 0">
                            <tr>
                                <td :colspan="6">
                                    <i>No records available</i>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <pagination
                :current-page="filter.page"
                :totalPages="totalPages"
                :isLoading="isLoading"
                @change-page="page => changePage(page)"
            />
        </div>

        <modal-delete ref="modalDelete" @reload="getProductionCredits()" />
        <modal-update ref="modalUpdate" @reload="getProductionCredits()" />
    </div>
</template>

<script>
import productionCreditsService from "@/services/setting/production-credits";

export default {
    components: {
        LoaderList: () => import("@/components/elements/loader-list.vue"),
        Sorting: () => import("@/module/commons/sorting.vue"),
        Pagination: () => import("@/components/commons/pagination.vue"),
        InputSearchIcon: () => import("@/module/commons/input-search-icon.vue"),
        // Spinner: () => import("@/components/elements/spinner.vue"),
        ModalDelete: () => import("./modal-delete.vue"),
        ModalUpdate: () => import("./modal-update.vue"),
        Dropdown: () => import("@/components/commons/dropdown.vue")
    },
    data() {
        return {
            productionCredits: [],
            categoryLookup: {},
            allCategoryLabels: "",
            status: [
                {
                    label: "All",
                    value: ""
                },
                {
                    label: "Active",
                    value: 1
                },
                {
                    label: "Disabled",
                    value: 3
                }
            ],
            isLoading: true,
            filter: {
                search: "",
                sortColumn: "",
                sortDirection: "",
                status: "",
                perPage: 20,
                page: 1
            },
            totalPages: 0
        };
    },
    async created() {
        await this.getCategories();

        this.getProductionCredits();
    },
    watch: {
        filter: {
            handler() {
                this.getProductionCredits();
            },
            deep: true
        },
        refresh() {
            this.getProductionCredits();
        }
    },
    methods: {
        remove(data = {}) {
            this.$refs.modalDelete.open(
                data,
                data?.total_used.toUpperCase() === "NO" ? true : false
            );
        },
        openUpdateDialog(data = null, isDuplicate = false) {
            this.$refs.modalUpdate.open(data, isDuplicate);
        },
        async getProductionCredits() {
            this.isLoading = true;
            const res = await productionCreditsService.getProductionCredits(
                this.filter
            );
            const { meta, data } = res.data.response.resource;
            if (res.status == 200) {
                this.productionCredits = data;
                this.totalPages = meta?.lastPage || 0;
            }
            this.isLoading = false;
        },
        sortingData(orderBy, col) {
            this.filter.page = 1;
            this.filter.sortColumn = col;
            this.filter.sortDirection = orderBy;
        },
        changePage(page) {
            this.filter.page = page;
        },
        searchProductionCredits(keyword) {
            this.filter.search = keyword;
            this.resetFilter();
        },
        resetFilter() {
            this.filter.sortColumn = "";
            this.filter.sortDirection = "";
            this.filter.page = 1;
        },
        async getCategories() {
            var res = await this.$http.get(
                process.env.BARRAMUNDI + "inventory/category-by-type"
            );

            if (res.data.response.message.code === 200) {
                var result = res.data.response.resources;
                var catLookup = this.generateCategoryLookup(result);
                this.categoryLookup = catLookup.lookup;
                this.allCategoryLabels = catLookup.allLabels;
            }
        },
        generateCategoryLookup: function (rawList = []) {
            var lookup = {};
            var tempLabels = [];

            for (var n = 0; n < rawList.length; n++) {
                var record = rawList[n];

                for (var c = 0; c < record.category.length; c++) {
                    var item = record.category[c];
                    lookup[item.id] = item;
                    tempLabels.push(item.name);
                }
            }

            return {
                lookup: lookup,
                allLabels: tempLabels.join(", ")
            };
        },
        categoryLabel: function (allCategory, categories = []) {
            if (allCategory === 1) {
                return "All categories";
            }
            if (allCategory === 0) {
                var lookup = this.categoryLookup;
                var temp = [];

                _.forEach(categories, function (data) {
                    if (typeof lookup[data.category_id] !== "undefined") {
                        temp.push(lookup[data.category_id].name || "-");
                    }
                });

                return temp.join(", ");
            }
        },
        statusLabel(value) {
            return this.status.find(item => item.value === value)?.label;
        },
        setStatus(data) {
            this.filter.status = data.value;
        }
    }
};
</script>
